import { ReactNode, createContext } from 'react';

import { EvaluatorStoreType } from './evaluatorStore';

// Context for determining which store to use
export const EvaluatorStoreContext = createContext<EvaluatorStoreType>('crud');

// Provider component
interface EvaluatorStoreProviderProps {
  children: ReactNode;
  storeType: EvaluatorStoreType;
}

export const EvaluatorStoreProvider = ({
  children,
  storeType,
}: EvaluatorStoreProviderProps) => {
  return (
    <EvaluatorStoreContext.Provider value={storeType}>
      {children}
    </EvaluatorStoreContext.Provider>
  );
};
